// extracted by mini-css-extract-plugin
module.exports = {"container":"AboutSection_container__9gD5m","descTitle":"AboutSection_descTitle__zpdcr","description":"AboutSection_description__5lYMR"};